<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-col :md="24" :lg="10">

        <a-form layout="vertical">
          <a-form-item
            label="项目名称"
          >
            <a-input ref="projectName" :defaultValue="name"/>
          </a-form-item>

          <a-form-item
            label="项目描述"
          >
            <a-textarea rows="4" ref="projectDescription" :defaultValue="description"/>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="handleSave">保存</a-button>
          </a-form-item>
        </a-form>

      </a-col>
    </a-row>
  </div>
</template>

<script>
import { editItem } from '@/api/item'

export default {
  name: 'Information',
  data () {
    return {
      name: '',
      description: ''
    }
  },
  created () {
    this.name = this.$store.getters.projectData.name
    this.description = this.$store.getters.projectData.description
  },

  methods: {
    handleSave () {
      const name = this.$refs.projectName.stateValue
      const description = this.$refs.projectDescription.stateValue

      const data = {
        item_name: name,
        item_des: description,
        item_id: this.$store.getters.projectId,
        label_type: this.$store.getters.projectData.labelType
      }
      const _this = this
      editItem(data).then(res => {
        if (res.code != 200){
              _this.$message.error(res.msg)
            }
        else{
               _this.$message.success(res.msg);  
            }
        _this.$store.dispatch('updateProjectData', { name: name, description: item_des })
      }).catch(() => {
      }).finally(_this.close)
    }

  }
}
</script>
